// extracted by mini-css-extract-plugin
export default {"bottomposter":"BottomPoster_bottomposter__++D3r"};